export default __webpack_public_path__ + "static/media/breakingWalls.80dc5038.svg";